import { getInquiryHsycbh, createInquiryHsycbh } from 'src/api';
import { makeAutoObservable, runInAction } from 'mobx';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import LoadingService from 'src/utils/LoadingService';
import PopupService from 'src/utils/PopupService';
import i18n from 'src/lang/i18n';
import InsuranceFeeInfo from 'src/models/InsuranceFeeInfo';
import { FORMAT_DATE_YYYY_MM_DD } from '../constants';
dayjs.extend(customParseFormat);

export class FeeStore {
  feeInfo: InsuranceFeeInfo;

  constructor() {
    makeAutoObservable(this);
  }

  async getInquiryHsycbh(contractCode: string, history) {
    try {
      LoadingService.instance.current.open();
      const inquiryHsycbhRes = await getInquiryHsycbh(contractCode);
      console.log('inquiryHsycbhRes', inquiryHsycbhRes?.data);
      LoadingService.instance.current.close();
      runInAction(() => {
        this.feeInfo = inquiryHsycbhRes.data;
      });
      history.push('/online-payment/confirm');
    } catch (err) {
      LoadingService.instance.current.close();
      console.log('inquiryHsycbh err', err?.response);
      if (err?.response?.status == 400) {
        PopupService.instance.current.open({
          visible: true,
          title: i18n.t('notification'),
          content: err?.response?.data?.error_message,
          cancelTitle: i18n.t('later'),
          showContactButton: true,
          onOk: () => {
            PopupService.instance.current.close();
          },
          onCancel: () => {
            PopupService.instance.current.close();
          },
        });
      }
    }
  }

  async createInquiryHsycbh() {
    if (!this.feeInfo || !this.feeInfo.requestId) return;
    try {
      LoadingService.instance.current.open();
      const createInquiryHsycbhRes = await createInquiryHsycbh(
        this.feeInfo.requestId
      );
      LoadingService.instance.current.close();
      console.log('createInquiryHsycbhRes', createInquiryHsycbhRes?.data);
      if (window?.ReactNativeWebView) {
        window?.ReactNativeWebView?.postMessage(
          JSON.stringify({
            type: 'PAYMENT_HUB_TRANSACTION',
            data: createInquiryHsycbhRes?.data,
          })
        );
      }
    } catch (err) {
      LoadingService.instance.current.close();
      console.log('createInquiryHsycbh err', err);
      if (err?.response?.status == 400) {
        PopupService.instance.current.open({
          visible: true,
          title: i18n.t('notification'),
          content: err?.response?.data?.error_message,
          cancelTitle: i18n.t('later'),
          showContactButton: true,
          onOk: () => {
            PopupService.instance.current.close();
          },
          onCancel: () => {
            PopupService.instance.current.close();
          },
        });
      }
    }
  }
}

export default new FeeStore();
